import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { FileToImport } from '~/front-models/fileToImport';
import { AddressSummary } from '~/models/modules/address';
import { FormTabSummary } from '~/models/modules/formTab';
import { GridFieldSummary } from '~/models/modules/gridField';
import { ApiServiceBase, API_NAMES } from '~/services/api';

@Injectable({ providedIn: 'root' })
export class GridFieldsService extends ApiServiceBase {
  constructor(injector: Injector, private http: HttpClient) {
    super(injector);
    this.setBase(API_NAMES.common);
  }

  getGridFieldsByPage(page: string, isReport: boolean = false) {
    const headers = {
      // 'Accept-Encoding': 'none'
    }
    const requestOptions = {
      headers: new HttpHeaders(headers),
    };
    return this.http.get<GridFieldSummary>(this._url(`/${page}/${isReport}`), requestOptions);
  }

  getByPageForImportStockItemLocationMinMax(page: string, language?: string) {
    return this.http.get<GridFieldSummary>(this._url(`/LocationMinMaxFields/${page}/${language}`));
  }

  getByPageForImportAssignAsset(page: string, language?: string) {
    return this.http.get<GridFieldSummary>(this._url(`/AssignAssetFields/${page}/${language}`));
  }

  getGridFieldsWithRelatedCustomFieldsByPage(page: string, relatedCustomFields: string, isReport: boolean = false) {
    //return this.http.get<AddressSummary>(this._url(`/pageByRelatedCustomFields/${page}/${relatedCustomFields}/${isReport}`));
    return this.http.get<GridFieldSummary>(this._url(`/pageByRelatedCustomFields/${page}/${isReport}`));
  }

  getSelectedReportGridFields(reportId: number) {
    return this.http.get<GridFieldSummary>(this._url(`/GetSelectedReportGridFields/${reportId}`));
  }

  getGridFieldTextLabelByPage(page: string, language: string) {
    return this.http.get(this._url(`/GetLabelByPage/${page}/${language}`));
  }

  updateGridFieldTextLabelByObjectCode(model: any) {
    return this.client.put(this._url('/UpdateGridFieldTextLabel'), model);
  }

  updateGridField(model: any) {
    return this.client.put(this._url(), model);
  }

  updateGridFieldOrder(model: any) {
    return this.client.put(this._url(`/reorder`), model);
  }
  updateGridFieldSort(model: any) {
    return this.client.put(this._url(`/updatesort`), model);
  }

  getRenameAuthByObjectCode(objectCode: string) {
    return this.client.get(this._url(`/RenameAuthorization/${encodeURIComponent(objectCode)}`));
  }

  getCustomFieldAuthByName(name: string, page: string) {
    return this.client.get(this._url(`/CustomFieldAuthorization/${encodeURIComponent(name)}/${encodeURIComponent(page)}`));
  }

  getSystemFieldsByPage(page: string) {
    return this.client.get(this._url(`/GetSystemFieldsByPage/${encodeURIComponent(page)}`));
  }
  getSystemAndCustomFieldsByPage(entity: string, page: string = null, entityId: string = null) {
    return this.client.get(this._url(`/GetSystemAndCustomFieldsByPage/${entity}/${page}/${entityId}`));
  }

  updateRenameAuthByObjectCode(model: any) {
    return this.client.put(this._url(`/UpdateAuthorization`), model);
  }

  updateCustomAuthBuName(model: any) {
    return this.client.put(this._url(`/UpdateCustomFieldAuthorization`), model);
  }

  getformTabsByPage(page: string) {
    return this.client.get<FormTabSummary[]>(this._url(`/GetFormTabs/${encodeURIComponent(page)}`));
  }

  updateFormTabsReorder(model: any) {
    return this.client.put(this._url(`/UpdateFormTabsOrder`), model);
  }

  updatedSystemFieldReorder(model: any) {
    return this.client.put(this._url(`/UpdateSystemFieldsOrder`), model);
  }

  getFileAuthorization(fileName: string, roleId: number) {
    return this.client.get(this._url(`/getFileAuthorization/${fileName}/${roleId}`));
  }

  getFieldsAuthorization(page: string, roleId: number) {
    const headers = {
      // 'Accept-Encoding': 'none'
    }
    const requestOptions = {
      headers: new HttpHeaders(headers),
    };
    return this.client.get(this._url(`/getFieldAuthorization/${page}/${roleId}`), requestOptions);
  }

  getCustomFieldAuth(page: string, roleId: number) {
    return this.client.get(this._url(`/getCustomFieldAuthorization/${page}/${roleId}`));
  }

  getEditForms(page: string): Observable<FormTabSummary[]> {
    return this.client.get<FormTabSummary[]>(this._url(`/GetEditFormByPage/${page}`));
  }

  getFilterOptions(page: string, field: string, isCustomField: boolean) {
    return this.client.get(this._url(`/getFilterOptions/${page}/${field}/${isCustomField}`));
  }

  updateEditForms(formTab: FormTabSummary[]) {
    return this.client.put<boolean>(this._url(`/UpdateEditFormByPage`), formTab);
  }

  exportToWord(word: boolean = true): Observable<Blob> {
    return this.client.post<Blob>(this._url(`/ExportToWord`), word);
  }

  resetFieldNames() {
    return this.client.get(this._url(`/ResetFieldNames`));
  }

  GetMapFieldsForImportByPage(page: string, language?: string) {
    return this.http.get<FileToImport>(this._url(`/GetMapFieldsForImportByPage/${page}/${language}`));
  }

  getAllPages(baseStr?: string) {
    let params = new HttpParams();
    if (baseStr) {
      params = params.set('baseStr', baseStr);
    }
    return this.client.get<any>(this._url(`/GetAllPages`), { params });
  }
  getPageByName(pageName: string) {
    return this.client.get<any>(this._url(`/GetPageByName/${pageName}`));
  }
  EditPageTitle(pagename: string, pagetitle: string) {
    let pageEditModel =
    {
      pageName: pagename,
      pageTitle: pagetitle
    }
    return this.client.put<any>(this._url(`/EditPageTitleByPageName`), pageEditModel);
  }

  private _url(v?: string | undefined) {
    v = v || '';
    return this.url(`/GridFields${v}`);
  }
}
